import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    projectSettings: string;
    notifications: string;
    project: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label that opens project settings from the project switcher menu */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectMenu.projectSettings?c=2okd1owibl5lb", defaultMessage: "Project Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the project notifications toggle in the project switcher menu */
            notifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectMenu.notifications?c=1bmhy5j8pv1g6", defaultMessage: "Notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group label for project-related actions in the project switcher */
            project: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectMenu.project?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
